import * as React from "react";
import { TextBox } from "../../forms/informedv2/TextBox";
import { useReferenceContextProvider } from "../../Core/ReferenceContextProvider";
import { MultiSelect } from "../../forms/informedv2/MultiSelect";
import { StudySessionType } from "webportalclient";
import { EmailValidator } from "../../forms/validation/EmailValidator";

export interface OverreadForm {
    SessionTypes: StudySessionType[];
    ChallengeNotificationEmail: string;
    StudyContactEmail: string;
}

export const StudyOverreadForm = () => {
    const { sessionTypes } = useReferenceContextProvider();

    return (
        <>
            <div className="row">
                <div className="form-group col-md-4 col-sm-4 col-xs-12">
                    <label htmlFor="Name">Session Types</label>
                    <MultiSelect
                        id="SessionTypes"
                        field="SessionTypes"
                        labelKey="name"
                        valueKey="id"
                        multi
                        options={sessionTypes}
                    />
                </div>
                <div className="form-group col-md-4 col-sm-4 col-xs-12">
                    <label htmlFor="StudyContactEmail">Study contact email</label>
                    <TextBox<string, OverreadForm>
                        id="StudyContactEmail"
                        field="StudyContactEmail"
                        type="email"
                        validate={(value) => value === undefined || value === null ? undefined : EmailValidator(value)}
                    />
                </div>
                <div className="form-group col-md-4 col-sm-4 col-xs-12">
                    <label htmlFor="ChallengeNotificationEmail">Over-reading challenge notification email</label>
                    <TextBox<string, OverreadForm>
                        id="ChallengeNotificationEmail"
                        field="ChallengeNotificationEmail"
                        type="email"
                        validate={(value) => value === undefined || value === null ? undefined : EmailValidator(value)}
                    />
                </div>
            </div>
        </>
    );
}
